import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import BackgroundLayer from "../components/BackgroundLayer";

export default function AuthCallbackScreen() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data.user);
        // Clear hash and navigate
        window.history.replaceState(null, "", "/home");
        navigate("/home", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      <BackgroundLayer section="auth" />
      <div className="text-center fade-up" data-testid="auth-callback">
        <span className="inline-block w-4 h-4 rounded-full bg-[#4CAF50] dot-pulse" />
        <p className="text-white/70 mt-4">Signing you in…</p>
      </div>
    </div>
  );
}
